// @ts-ignore
import { createSelector } from '@reduxjs/toolkit';
import { SortOptions, TripTypes } from '@model/common';
import { Months } from '@model/common/dates';
import { GlobalAppState } from '@model/state';

const selectNavigationState = (state: GlobalAppState) => state.navigation;

export const getSelectedSortOption = createSelector(
  [selectNavigationState],
  (navigation): SortOptions => navigation.selectedSortOption
);

export const getTripTypeFilter = createSelector(
  [selectNavigationState],
  (navigation): TripTypes => navigation.selectedFilter
);

export const getSelectedMonth = createSelector(
  [selectNavigationState],
  (navigation): Months => navigation.selectedMonth
);

export const getSelectedAirport = createSelector(
  [selectNavigationState],
  (navigation): string => navigation.selectedAirport
);

export const getNavigationFilters = createSelector(
  [getTripTypeFilter, getSelectedSortOption, getSelectedMonth, getSelectedAirport],
  (filter, sortOption, month, airport) => ({
    filter,
    sortOption,
    month,
    airport
  })
);
